import { render, staticRenderFns } from "./ModalSucessoContaServico.vue?vue&type=template&id=09bfea05&scoped=true"
import script from "./ModalSucessoContaServico.vue?vue&type=script&lang=js"
export * from "./ModalSucessoContaServico.vue?vue&type=script&lang=js"
import style0 from "./ModalSucessoContaServico.vue?vue&type=style&index=0&id=09bfea05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bfea05",
  null
  
)

export default component.exports